<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from 'svelte-i18n';
	import { zendureRequest } from 'src/services/zendure_reqs';
	//Stores
		//Design system components
	import { Input, Loader, Button, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { makeNumbersPrimaryAndBold } from 'src/helpers/utilities';
	import { real_id } from 'src/helpers/interface_helpers';

	$: settingsStore = getDeviceSettings(device.id);
	export let device;

	let settings = $settingsStore;

	let outputLimit = settings?.outputLimit || 0;
	let cache = outputLimit;

	let error = false;
	let loading = false;
	const min = 0;
	const max = 1200;

	const setoutputLimit = async () => {
		if (cache === outputLimit) return;

		let res;
		loading = true;

		res = await zendureRequest(device.id, {
			output_limit: isNaN(Number(outputLimit)) ? 0 : Number(outputLimit),
		});
		if (res?.isok) {
			cache = outputLimit;
		}
		onSettingsResponse(res, device);

		loading = false;
	};
</script>

{#if loading}
	<Loader size="m" />
{:else}
	<Text styleType="controls-small" class="mb-s">
		{@html makeNumbersPrimaryAndBold(
			`${$format('output_limit_description', {
				default: `Set maximum output power to home`,
			})}`,
		)}
	</Text>

	<Input
		aria-label={$format('input_set_output_limit', {
			default: 'Input set output limit',
		})}
		size="m"
		icon="fas fa-house-day"
		bind:value={outputLimit}
		type={'number'}
		step={1}
		info={$format('range_min_max_watts_value', {
			default: 'Range: {min} W - {max} W.',
			values: { min, max },
		})}
		error={error
			? $format('setting_err_toast', {
					default: 'Failed to apply settings.',
				})
			: ''}
		on:enter={setoutputLimit}
		on:focus={() => {
			error = false;
		}}
		id="input-pl9u3du"
	/>
{/if}

<Button class="mt-s" {loading} size="m" width="full" disabled={loading} on:click={setoutputLimit}
	>{$format('button_save')}</Button
>
